import {
  Box,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import React from "react";

interface AuthProps {
  children: React.ReactNode;
}

const Auth: React.FC<AuthProps> = ({ children }) => {
  const [isMobile] = useMediaQuery("(max-width: 768px)");

  return (
    <Box
      width={"100vw"}
      height={"100vh"}
      bgImage="url('images/bg-auth.png')"
      bgPosition="center"
      bgSize={"cover"}
      bgRepeat="no-repeat"
      display="flex"
      alignItems="flex-start"
      justifyContent="center"
      p={0}
      flexDir="column"
      pos="relative"
      overflow="hidden"
    >
      {/* Logo/Branding */}
      <Box 
        pos="absolute" 
        top={{ base: "40px", md: "60px" }} 
        left="50%" 
        transform="translateX(-50%)"
        zIndex={2}
      >
        <Text
          className="dcalligraphy"
          color={"#fff"}
          fontSize={{ base: "1.2rem", md: "2.5rem" }}
          transform="rotate(-8deg)"
          textShadow="0 2px 4px rgba(0,0,0,0.3)"
          fontWeight="400"
        >
          Weddn.co
        </Text>
      </Box>

      {/* Main Content Container */}
      <Box
        w="full"
        h={{ base: "calc(100vh - 120px)", md: "731px" }}
        maxH={{ base: "none", md: "80vh" }}
        mt={{ base: "120px", md: "140px" }}
        mx={{ base: 0, md: "auto" }}
        maxW={{ base: "none", md: "500px", lg:"640px" }}
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent={{ base: "flex-start", md: "center" }}
        fontFamily="optima"
        p={{ base: "60px 24px", md: "60px 40px" }}
        overflowY="auto"
        boxShadow={{ base: "none", md: "0 10px 40px rgba(0,0,0,0.1)" }}
        className="no-scrollbar"
        bg="rgba(255,255,255,0.85)"
        backdropFilter="blur(10px)"
      >
        {children}
      </Box>
    </Box>
  );
};

export default Auth;
